import React from "react";
import {
  DEBUG_PLATFORM_OVERRIDE_KEY,
  PLATFORM,
  PLATFORM_IS_NATIVE,
  type PlatformName
} from "src/hybrid/components/Platform";
import {
  DebugBadge,
  DebugButton,
  DebugButtonRow,
  DebugInfoBox,
  DebugKeyValue
} from "./debug.styles";

const setOverride = (next: PlatformName | null): void => {
  if (next === null) {
    localStorage.removeItem(DEBUG_PLATFORM_OVERRIDE_KEY);
  } else {
    localStorage.setItem(DEBUG_PLATFORM_OVERRIDE_KEY, next);
  }
  window.location.reload();
};

const DebugPlatform: React.FC = () => {
  const currentOverride = (() => {
    try {
      return localStorage.getItem(DEBUG_PLATFORM_OVERRIDE_KEY);
    } catch {
      return null;
    }
  })();

  return (
    <div>
      <DebugKeyValue>
        <span className="key">PLATFORM</span>
        <span className="value">
          <DebugBadge variant="info">{PLATFORM}</DebugBadge>
        </span>
      </DebugKeyValue>
      <DebugKeyValue>
        <span className="key">Is Native</span>
        <span className="value">
          <DebugBadge variant={PLATFORM_IS_NATIVE ? "success" : "info"}>
            {PLATFORM_IS_NATIVE ? "true" : "false"}
          </DebugBadge>
        </span>
      </DebugKeyValue>
      <DebugKeyValue>
        <span className="key">Override</span>
        <span className="value">
          {currentOverride ? (
            <DebugBadge variant="warning">{currentOverride}</DebugBadge>
          ) : (
            <DebugBadge>none</DebugBadge>
          )}
        </span>
      </DebugKeyValue>

      <DebugInfoBox variant="info" style={{ marginTop: "0.75rem" }}>
        <p>
          Simulate running as a hybrid app. Changing this reloads the page so
          all platform-dependent code re-evaluates. Only code that reads
          <code> isHybridApp / isIOS / isAndroid / PLATFORM</code> is affected;
          native Capacitor plugins still report the real platform.
        </p>
      </DebugInfoBox>

      <DebugButtonRow style={{ marginTop: "0.75rem" }}>
        <DebugButton onClick={() => setOverride("ios")}>
          Simulate iOS
        </DebugButton>
        <DebugButton onClick={() => setOverride("android")}>
          Simulate Android
        </DebugButton>
        <DebugButton onClick={() => setOverride("web")}>Force Web</DebugButton>
        <DebugButton
          className="danger"
          onClick={() => setOverride(null)}
          disabled={!currentOverride}
        >
          Clear Override
        </DebugButton>
      </DebugButtonRow>
    </div>
  );
};

export default DebugPlatform;
